(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2780],{

/***/ 89495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ NextProductPage; }
/* harmony export */ });
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50029);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _shopify_react_idle__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(17548);
/* harmony import */ var _fh_components_fh_js_api_core_store_slices_productSlice__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73278);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12325);
/* harmony import */ var _lib_handleError__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67408);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(74030);
/* harmony import */ var _seo_Ecommerce__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(31893);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85893);











var ProductPage = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function () {
  return __webpack_require__.e(/* import() */ 8534).then(__webpack_require__.bind(__webpack_require__, 18534));
}, {
  loading: function loading() {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(_components__WEBPACK_IMPORTED_MODULE_6__/* .Loader */ .aN, {});
  },
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(18534)];
    }
  }
});
function NextProductPage() {
  var setPageType = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function () {
    _seo_Ecommerce__WEBPACK_IMPORTED_MODULE_7__/* ["default"].setPageType */ .ZP.setPageType(_seo_Ecommerce__WEBPACK_IMPORTED_MODULE_7__/* ["default"].PAGE_TYPES.PRODUCT */ .ZP.PAGE_TYPES.PRODUCT);
  }, []);
  (0,_shopify_react_idle__WEBPACK_IMPORTED_MODULE_9__/* .useIdleCallback */ .Y)(setPageType);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(ProductPage, {});
}

NextProductPage.getInitialProps = /*#__PURE__*/function () {
  var _ref2 = (0,_app_web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)( /*#__PURE__*/_app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(_ref) {
    var query, reduxStore, productId, error;
    return _app_web_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            query = _ref.query, reduxStore = _ref.reduxStore;
            productId = query.productId;
            _context.next = 4;
            return reduxStore.dispatch((0,_fh_components_fh_js_api_core_store_slices_productSlice__WEBPACK_IMPORTED_MODULE_3__/* .fetchProductPage */ .mr)({
              slug: productId
            }));

          case 4:
            error = (0,_store__WEBPACK_IMPORTED_MODULE_4__/* .productErrorSelector */ .Mg)(reduxStore.getState());
            (0,_lib_handleError__WEBPACK_IMPORTED_MODULE_5__/* .handleError */ .S)(error);
            return _context.abrupt("return", {});

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

/***/ }),

/***/ 7415:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product/[productId]",
      function () {
        return __webpack_require__(89495);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 17548:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ useIdleCallback; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@shopify/react-idle/build/esm/types.mjs
let UnsupportedBehavior;

(function (UnsupportedBehavior) {
  UnsupportedBehavior[UnsupportedBehavior["Immediate"] = 0] = "Immediate";
  UnsupportedBehavior[UnsupportedBehavior["AnimationFrame"] = 1] = "AnimationFrame";
})(UnsupportedBehavior || (UnsupportedBehavior = {}));



;// CONCATENATED MODULE: ./node_modules/@shopify/react-idle/build/esm/hooks.mjs



function useIdleCallback(callback, {
  unsupportedBehavior = UnsupportedBehavior.AnimationFrame
} = {}) {
  const handle = (0,react.useRef)(null);
  (0,react.useEffect)(() => {
    if ('requestIdleCallback' in window) {
      handle.current = window.requestIdleCallback(() => callback());
    } else if (unsupportedBehavior === UnsupportedBehavior.AnimationFrame) {
      handle.current = window.requestAnimationFrame(() => {
        callback();
      });
    } else {
      callback();
    }

    return () => {
      const {
        current: currentHandle
      } = handle;
      handle.current = null;

      if (currentHandle == null) {
        return;
      }

      if ('cancelIdleCallback' in window) {
        window.cancelIdleCallback(currentHandle);
      } else if (unsupportedBehavior === UnsupportedBehavior.AnimationFrame) {
        window.cancelAnimationFrame(currentHandle);
      }
    };
  }, [callback, unsupportedBehavior]);
}




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(7415); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);